<template>
  <div>
    <div
      v-for="(item, index) in walletTypes"
      v-if="item.permission"
      :key="index"
      class="my-0 py-0"
    >
      <v-switch
        v-model="value[item.value]"
        :label="item.title"
        class="my-0 py-0"
      ></v-switch>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "payLadderComponent",
  props: {
    value: {
      default: {
        wallet: true,
        divarPanel: false,
        divarWallet: false,
      },
    },
    usersPanel: {
      default: [],
    },
    phone: {
      default: undefined,
    },
  },
  data() {
    return {
      walletTypes: [
        {
          title: "پرداخت مستقیم از کیف پول سامانه",
          value: "wallet",
          permission: true,
        },
        {
          title: "پرداخت از بسته نردبان دیوار",
          value: "divarPanel",
          permission: false,
        },
        {
          title: "پرداخت از کیف پول دیوار",
          value: "divarWallet",
          permission: false,
        },
      ],
      panel: "",
    };
  },
  watch: {
    value: {
      handler(val) {
        let pack = this.core.pack[0];
        let hasPanel = [18, 19, 25, 26, 27].indexOf(pack.id) > 0;

        this.usersPanel.forEach(
          (item) =>
            (hasPanel = hasPanel && [18, 19, 25, 26, 27].indexOf(item) > 0)
        );

        if (!hasPanel && !val.wallet && !this.phone.is_pro) {
          this.$modal.error(
            "",
            `شماره ${this.phone.phone} اعتبار پرو ندارد!`,
            "",
            {
              text: "لیست شماره‌های من",
              icon: "fa-plus",
              class: "btn col-md-12 btn-outline-lightGreen my-1",
              onClick() {
                window.open(
                  this.$robotCoreApi + "/#/Numbers/numberList",
                  "_blank"
                );
              },
            }
          );

          this.$nextTick(() => {
            this.$emit("input", {
              ...val,
              wallet: true,
            });
          });
        }
      },
      deep: true,
    },
    phone: {
      deep: true,
      handler() {
        this.$emit("input", {
          ...this.value,
          wallet: true,
        });
      },
    },
  },
  computed: {
    ...mapGetters("ribbon", {
      core: "core",
    }),
  },
};
</script>

<style scoped></style>
